import {
  AlertCircle,
  ArrowRight,
  Instagram,
  Facebook,
  MessageCircle,
} from "lucide-react";
import { WHATSAPP_LINK } from "../constants";

const SOCIAL = [
  {
    icon: Instagram,
    label: "Instagram",
    href: "https://www.instagram.com/perasciano/",
  },
  {
    icon: Facebook,
    label: "Facebook",
    href: "https://www.facebook.com/perasciano",
  },
  {
    icon: MessageCircle,
    label: "Bacheca WhatsApp",
    href: WHATSAPP_LINK,
  },
];

export const HowToParticipate = () => {
  return (
    <section
      id="partecipa"
      data-testid="participate-section"
      className="relative py-20 sm:py-24 bg-[#FBF9F6] overflow-hidden border-t border-[#E5E1D8]"
    >
      <div className="pointer-events-none absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-[#C15C3D]/[0.05] blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-[#2E4F3B]/[0.06] blur-3xl" />

      <div className="relative max-w-5xl mx-auto px-6 sm:px-8 lg:px-12">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-10 sm:mb-12">
          <span className="inline-block text-xs sm:text-sm font-bold uppercase tracking-[0.22em] text-[#C15C3D] mb-4">
            Altri modi per partecipare
          </span>
          <h2
            data-testid="participate-title"
            className="font-display text-3xl sm:text-4xl lg:text-5xl font-black text-[#1A1A1A] leading-[1.05] tracking-tight"
          >
            Non solo volontariato
            <span className="text-[#2E4F3B]">.</span>
          </h2>
          <p className="mt-5 text-base sm:text-lg text-[#5C5C5C] leading-relaxed">
            Ci sono molti modi per essere parte della comunità. Segnalaci ciò
            che vedi sul territorio o restai in contatto sui nostri canali.
          </p>
        </div>

        {/* Segnalazione */}
        <a
          href="/segnalazioni"
          data-testid="participate-report-link"
          className="group flex items-center gap-4 sm:gap-5 rounded-2xl bg-white border-2 border-[#E5E1D8] hover:border-[#2E4F3B] p-5 sm:p-6 transition-colors"
        >
          <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-[#2E4F3B] text-white flex items-center justify-center shrink-0">
            <AlertCircle className="w-6 h-6 sm:w-7 sm:h-7" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-display font-black text-lg sm:text-xl text-[#1A1A1A] leading-tight">
              Hai una segnalazione?
            </div>
            <div className="text-sm sm:text-base text-[#5C5C5C] mt-1 leading-relaxed">
              Una zona da pulire, un pericolo, una persona in difficoltà:
              dicci cosa serve.
            </div>
          </div>
          <ArrowRight className="w-5 h-5 text-[#2E4F3B] shrink-0 transition-transform group-hover:translate-x-1" />
        </a>

        {/* Social */}
        <div className="mt-10 sm:mt-12 pt-10 border-t border-[#E5E1D8]">
          <div className="text-center">
            <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.18em] text-[#5C5C5C] mb-5">
              Seguici sui nostri canali
            </p>
            <div className="flex items-center justify-center gap-3">
              {SOCIAL.map((s) => {
                const Icon = s.icon;
                return (
                  <a
                    key={s.label}
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={s.label}
                    data-testid={`social-${s.label.toLowerCase().replace(/\s/g, "-")}`}
                    className="group inline-flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-white border-2 border-[#E5E1D8] text-[#5C5C5C] hover:bg-[#1A1A1A] hover:border-[#1A1A1A] hover:text-white transition-colors"
                  >
                    <Icon className="w-5 h-5 sm:w-6 sm:h-6" strokeWidth={1.8} />
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
